module.exports = __webpack_public_path__ + "img/lu.fdde7436.svg";